import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SagaActions } from "../../redux/actionTypes";
import CryptoJS from "crypto-js";
import { ROUTE_NAMES } from "../../constants/routeNames";
import { toast } from "react-toastify";

const RedirectLoadingPage = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const Dispatch = useDispatch();
  const { token } = useParams();

  const redirectFun = async () => {
    try {
      if (location.pathname.includes("/from-eadmin/loading")) {
        if (!token) return;
        const _tokenIs = token.replaceAll("$", "/");
        const bytes = CryptoJS.AES.decrypt(_tokenIs, "vmzCareerX");
        // console.log(token, "id from param");
        const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        // console.log(data, "decrypt token");
        localStorage.setItem("refreshToken", data?.refreshToken);
        localStorage.setItem("@role", data?.roleIs);
        localStorage.setItem("userID", `${data?.userId}`);
        loginFun();
        return;
      }
    } catch (error) {
      console.log(error, "error in redirectFun");
    }
  };

  const loginFun = async () => {
    const role = localStorage.getItem("@role");
    const roleIs = role ? Number(role) : 0;

    if (roleIs === 301 || roleIs === 303 || roleIs === 302 || roleIs === 200) {
      toast.error("You are not authorised to access this");
      return;
    }

    navigation("/" + ROUTE_NAMES.Home);
  };

  useEffect(() => {
    redirectFun();
  }, []);

  return (
    <div className=" h-100 w-100 d-flex flex-column align-items-center justify-content-center  border-primary">
      <div className="p-2" onClick={loginFun}>
        Loading..
      </div>
    </div>
  );
};

export default RedirectLoadingPage;
